import http from "../../net/http-common";
import { PREPROCESS_URL } from "../../config";

export const prepareInit = (PDBFile: File) => {
  const form = new FormData();
  form.append("pdb_file", PDBFile);

  return http.post(`${PREPROCESS_URL}/prepare/init`, form, {
    headers: {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "http://localhost:3000",
    },
  });
};


export const removeLigand = ({
  jobId,
  ligand,
}: {
  jobId: string;
  ligand: string;
}) => {
  return http.post(
    `${PREPROCESS_URL}/prepare/${jobId}/remove-ligand`,
    {
      ligand_pattern: ligand,
    },
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "http://localhost:3000",
      },
    }
  );
};

export const extractChain = ({
  jobId,
  chain,
}: {
  jobId: string;
  chain: string;
}) => {
  return http.post(
    `${PREPROCESS_URL}/prepare/${jobId}/extract-chain`,
    {
      chain_id: chain,
    },
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "http://localhost:3000",
      },
    }
  );
};

export const fixStructure = (
  jobId: string) => {
  return http.post(
    `${PREPROCESS_URL}/prepare/${jobId}/fix-structure`,
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const addCaps = (
  jobId: string
) => {
  return http.post(
    `${PREPROCESS_URL}/prepare/${jobId}/add-caps`,
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const splitComplex = ({
  jobId,
  ligandName,
}: {
  jobId: string;
  ligandName: string;
}) => {
  return http.post(`${PREPROCESS_URL}/prepare/${jobId}/split-complex?ligand_name=${ligandName}`, {
    headers: {
      accept: "application/json",
    },
  });
};

export const protonateProtein = ({
  jobId,
  pH,
}: {
  jobId: string;
  pH: number;
}) => {
  return http.post(
    `${PREPROCESS_URL}/prepare/${jobId}/protonate-protein`,
    {
      pH: pH,
    },
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const convertLigand = ({
  jobId,
  pH,
}: {
  jobId: string;
  pH: number;
}) => {
  const body = new URLSearchParams();
  body.append("pH", pH.toString());

  return http.post(
    `${PREPROCESS_URL}/prepare/${jobId}/convert-ligand`,
    body,
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};



export const assignCharges = (
  jobId: string
) => {
  return http.post(
    `${PREPROCESS_URL}/prepare/${jobId}/assign-charges`,
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const finalProtonation = (
  jobId: string
) => {
  return http.post(
    `${PREPROCESS_URL}/prepare/${jobId}/final-protonation`,
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "http://localhost:3000",
      },
    }
  );
};
